import {
  SET_IS_DISPLAY_TITLE,
  SET_USER_NAME,
  SET_CAN_EDIT,
  UPDATE_NAVIGATION_LIST,
  UPDATE_NAVIGATION_LIST_SEARCH,
  SET_IS_NEW_FILE,
  SET_IS_NEW_FILE_MOBILE
} from "../constants";

export const setDisplayTitle = IsDisplayTitle => dispatch => {
  dispatch({
    type: SET_IS_DISPLAY_TITLE,
    payload: IsDisplayTitle
  });
};
export const setUserName = userName => dispatch => {
  dispatch({
    type: SET_USER_NAME,
    payload: userName
  });
};

export const setCanEdit = (canEdit = 0) => dispatch => {
  dispatch({
    type: SET_CAN_EDIT,
    payload: canEdit
  });
};

export const updateNavigationList = (navigationList = {}) => dispatch => {
  dispatch({
    type: UPDATE_NAVIGATION_LIST,
    payload: navigationList
  });
};

export const updateNavigationListSearch = (navigationListSearch = {}) => dispatch => {
  dispatch({
    type: UPDATE_NAVIGATION_LIST_SEARCH,
    payload: navigationListSearch
  });
};

export const setIsNewFile = (isNewFile = false) => dispatch => {
  dispatch({
    type: SET_IS_NEW_FILE,
    payload: isNewFile
  });
};

export const setIsNewFileMobile = (isNewFileMobile = true) => dispatch => {
  dispatch({
    type: SET_IS_NEW_FILE_MOBILE,
    payload: isNewFileMobile
  });
};


// WEBPACK FOOTER //
// ./src/actions/widgetAction.js